import { Ico, Image, Text, View } from 'components';
import Base, { Config } from 'components/sixshot/Base';
import React from 'react';
import { history } from 'modules/navigator';
import styles from './index.module.scss';

interface RechargeOption {
  id: number;
  value: number; // 积分
  gift: number; //赠送积分
  price: string; // 价格
  info: string
}

interface State {
  viewMode?: string
  userinfo?: any
  options: RechargeOption[];
  selectOptionIndex: number;
  requireScore: number;
  scores?: number;
  showAlert: boolean;
  showRuleModal?: boolean
  showDayCardModal?: boolean

  tibanOptions: any[]
  vipActivityInfo?: any
}

export default class ScoresRecharge extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '积分充值'
  };

  public state: State = {
    options: [],
    requireScore: 0,
    selectOptionIndex: 0,
    showAlert: false,
    showDayCardModal: false,

    tibanOptions: [
      {
			type: 'day',
			bgImage: this.assets.sixshot.tibanItemBg1,
			desc: '24小时内电话随便打',
			info: null
		}, 
    {
			type: 'month',
			bgImage: this.assets.sixshot.tibanItemBg2,
			desc: '30天内不限次数拨打替班电话（额外再送100积分）',
      tag: '额外再送100积分',
			info: null
		}]
  };

  public async didMount() {
    const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    const parmState = this.props.location.state || {}
    let viewMode = params.type || parmState.type || ''   // viewMode: "ti"  只显示替班卡
    if(viewMode == 'ti') {
      document.title='替班包月卡'
    }
    this.setState({
      viewMode: viewMode
    })


    this.getUserInfo()
    this.getVipActivity()
    await this.fetchScores();
    this.fetchScoresConfig();
    this.fetchRechargeList();
    this.fetchTibanRechargeList()
  }

  public render() {
    const { viewMode, userinfo, options, selectOptionIndex, scores, requireScore, showAlert, tibanOptions, showRuleModal, vipActivityInfo, showDayCardModal } = this.state;

    const showScoreView = viewMode !== 'ti'
    return (
      <View className={styles.container}>
        {showScoreView && 
          <View className={styles.scoresMain}>
            <View className={styles.infoBox}>
              {userinfo && 
                <View className={styles.avatar}>
                  <Image src={userinfo.avatar || ''} className={styles.img} />
                </View>
              }
              {userinfo && <Text className={styles.name}>{(userinfo.nickname || '').substr(0,2)}</Text>}
              <Text className={styles.txt}>
                （剩余积分：<Text className={styles.b}>{scores}</Text>）
              </Text>
              <View className={styles.btn} onClick={() => {
                this.navigator.push('advice')
              }}>
                <Text className={styles.t}>{"支付问题 >"}</Text>
              </View>
            </View>
            
            <View className={styles.panel}>
              <View className={styles.kevin}>
                <Text className={styles.noball}>购买积分</Text>
                <Text className={styles.veronica}>（单次拨打）</Text>
                <View style={{flex: 1}} />
                <View className={styles.btn} onClick={() => {
                  this.toggleRuleModal(true)
                }}>{"积分规则"}</View>
              </View>
              <View className={styles.options}>
                {options.map((option, index) => {
                  const selected = index === selectOptionIndex;
                  return (
                    <View
                      onClick={this.handleSelectOption.bind(this, index)}
                      className={this.cx(
                        styles.option,
                        selected && styles.active
                      )}
                    >
                      <View className={styles.opLeft}>
                        <Text className={styles.h2}>{option.value-option.gift}积分</Text>
                        <Text className={styles.h3}>+赠送{option.gift}积分</Text>
                      </View>
                      <View className={styles.opRight}>
                        <Text className={styles.p}>￥<Text className={styles.span}>{parseInt(option.price)}</Text></Text>
                        <Text className={styles.h6}>{"购买>>"}</Text>
                      </View>
                    </View>
                  )
                })}
              </View>
              <View className={styles.ad}>
              <Image
                className={styles.adIco}
                src={this.assets.sixshot.hornGray}
              />
              <View className={styles.adR}>
                <Text className={styles.txt}>有些招聘电话可能是错误的，会赠送积分，敬请谅解</Text>
              </View>
            </View>
            </View>
            <View className={styles.devider}></View>
          </View>
        }

        <View className={styles.ett}>
					<Ico src={this.assets.megatron.arrDownDouble} size={24} />
					<Text className={styles.ettxt}>替班活永久免費提醒</Text>
					<Ico src={this.assets.megatron.arrDownDouble} size={24} />
				</View>
        <View className={styles.tiban}>
					<View className={styles.inner}>
						
						<View className={styles.tabs}>
							{tibanOptions.map((res, ind) => (
                <View className={this.cx(styles.item, styles['item'+ind])} onClick={this.handleBeforeTibanPurchase.bind(null, res)}>
                    
                  <View className={styles.tabItem}>
                    <Image src={res.bgImage || ''} className={styles.img} />
                    <View className={styles.mid}>
                      <Text className={styles.h2}><Text className={styles.sm}>￥</Text>{res.info? Number(res.info.price): 0}</Text>
                    </View>
                  </View>
                </View>
							))}

                <View className={this.cx(styles.item, styles.item2)} onClick={() => {
									history.push('/payment/sixshotvipcompaire?type=2')
								}}>
                  <View className={styles.tabItem}>
										<Image src={this.assets.sixshot.tibanItemBg3} 
											className={styles.img}
										/>
                    <View className={styles.mid}>
											<Text className={styles.h2}><Text className={styles.sm}>￥</Text>{199}</Text>
										</View>
										
										{vipActivityInfo && 
											<View className={styles.btmBar}>
												<Text className={styles.txt}>
													{this.interface.formatDate(vipActivityInfo.activity_time*1000, 'yyyy.mm.dd')}
													前加入,额外
													<Text className={styles.red}>
														赠送
														<Text className={styles.b}>{vipActivityInfo.activity_content}个月</Text>
													</Text>
													钻石会员期限
												</Text>
											</View>
										}
									</View>
								</View>

              
						</View>
					</View>
				</View>

        <View className={styles.content}>
          <Text className={styles.h4}>温馨提醒：</Text>
          <View className={styles.p}>
            ①
            <Text style={{marginLeft: '10rpx'}}>只能打</Text>
            <Text className={styles.tbspan}>替班活</Text>
            <Text>标签工作</Text>
            <Text className={styles.red}> (包天卡不赠送积分)</Text>
          </View>
          <Text className={styles.p}>
            ②
            <Text style={{marginLeft: '10rpx'}}>积分可以用来“预定手机短信，或拨打长期活”</Text>
          </Text>
        </View>

          
        {showAlert && (
          <View className={styles.alertBox}>
            <View className={styles.alertBg}></View>
            <View className={styles.alertInner}>
              <View className={styles.alertTop}>
                <View className={styles.t1}>
                  <Text>已经赠送<Text className={styles.b}>{this.selectedOption.gift}</Text>积分给你</Text>
                </View>
                <View className={styles.t2}>考虑到有些招聘电话可能是错误的<br/>特意再赠送您积分<br/>请笑纳~
                  <Image
                    className={styles.img}
                    src={this.assets.sixshot.smile}
                  />
                </View>
              </View>
              <View className={styles.alertBottom}>
                <Text className={styles.txt}>遇到错误电话请谅解，并及时举报</Text>
                <View className={styles.Btn} onClick={this.hideAlert}>好的，我理解了</View>
              </View>
            </View>
          </View>
        )}
        {showRuleModal && (
          <View className={styles.alertBox}>
            <View className={styles.alertBg}></View>
            <View className={styles.alertInner}>
              <View className={styles.title}>积分使用规则</View>
              <View className={styles.ruleModal}>
                <View className={styles.cont}>
                  <Text className={styles.t1}>拨打招聘电话：</Text>
                  <Text className={styles.p}>1、积分永久有效，打1个电话消耗5积分</Text>
                  <Text className={styles.p}>2、每天一次免积分拨打机会，仅限长期工作免积分，但是不包括【高工资+上保险的】，免得抢了积分用户的机会！其它都是每天免积分一次。<br />替班时效性太强，不提供免积分拨打，不然买了替班的会员会有意见！</Text>
                  <View className={styles.dvd} />
                  <Text className={styles.t1}>拨打简历电话</Text>
                  <Text className={styles.p}>每天只能免费拨打电话1次，增加1次消耗5积分</Text>
                </View>
                <View className={styles.btns}>
                  <View className={styles.btn} onClick={() => {
                    this.toggleRuleModal(false)
                  }}>我知道了</View>
                </View>
              </View>
            </View>
          </View>
        )}

        {showDayCardModal && (
          <View className={styles.alertBox}>
            <View className={styles.alertBg} onClick={() => {
              this.setState({
                showDayCardModal: false
              })
            }}></View>
            <View className={styles.alertInner}>
              <View className={styles.title}>请看仔细：</View>
              <View className={styles.ruleModal}>
                <View className={styles.cont}>
                  <Text className={styles.h1}>重要的事情说3遍：</Text>
                  <Text className={styles.h5}>替班包天卡
                    <Text className={styles.red}>只能</Text>
                    打替班活，
                    <Text className={styles.red}>不能打长期</Text>
                  </Text>
                  <Text className={styles.h5}>替班包天卡
                    <Text className={styles.red}>只能</Text>
                    打替班活，
                    <Text className={styles.red}>不能打长期</Text>
                  </Text>
                  <Text className={styles.h5}>替班包天卡
                    <Text className={styles.red}>只能</Text>
                    打替班活，
                    <Text className={styles.red}>不能打长期</Text>
                  </Text>
                </View>
                <View className={styles.btns}>
                  <View className={styles.btn} onClick={() => {
                    this.setState({
                      showDayCardModal: false
                    })
                    this.handleTibanPurchase()
                  }}>了解，我主做替班</View>
                </View>
              </View>
            </View>
          </View>
        )}

      </View>
    );
  }


  private getUserInfo = async () => {
    const { body } = await this.apiClient.base.userinfo();

    this.setState({
      userinfo:body
    })

    // this.setState({
    //   userinfo: {"id":2,"nickname":"\u6211\u8ba4\u8bc6\u4f60","realname":"","mobile":"15267286145","mobile_location":"\u6d59\u6c5f\u53f0\u5dde(\u79fb\u52a8)","avatar":"https:\/\/assets.gongji58.com\/2019-02-27\/clavmj717r1551257843.png!medium","sex":1,"type":1,"reg_ip":"223.104.246.162","point":0,"id_number":"","address":"","address_id":null,"description":"","store_name":"\u6211\u8ba4\u8bc6\u4f60","store_description":"\u6d4b\u8bd5\u4e2a\u5443\u5443\u5443","car_total":54,"want_total":3,"job_total":12,"resume_total":11,"report_total":1,"last_login":"2021-06-11 11:40:54","ban_desc":"","developer":1,"status":3,"ctime":"2019-02-27 16:57:23","utime":"2020-09-15 11:38:48","is_manager":true,"id_checks":false,"pub_total":0}
    // })
  }

  private getVipActivity = async() => {
    const { body } = await this.apiClient.base.vipPlusActivity({
      type: 1
    })
    this.setState({
      vipActivityInfo: body
    })
  }

  private handlePurchase = async () => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }
    
    const response = await this.apiClient.base.purchaseScores({
      id: this.selectedOption.id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('充值成功');

        this.setState({
          showAlert:true
        });

        this.fetchScores();
      }
    });
  }

  private hideAlert = () => {
    this.setState({
      showAlert:false
    });
  }

  private toggleRuleModal = (state:boolean) => {
    this.setState({
      showRuleModal: !!state
    })
  }

  private fetchScoresConfig = async () => {
    const { body } = await this.apiClient.base.scoresConfig();

    const requireScore = Number(
      ((body || []).find(
        item => item.category === 'resume' && item.name === 'call_dec_score'
      ) || {}).value
    );

    this.setState({
      requireScore
    });
  }

  private fetchScores = async () => {

    const { body } = await this.apiClient.base.account();

    if (!body) {
      return;
    }

    this.setState({
      scores: body.score
    });
  }

  private fetchRechargeList = async () => {
    const { body: options } = await this.apiClient.base.scoresRechargeList();

    this.setState({
      options,
      selectOptionIndex: options.findIndex(option => !!option.selected) || 0
    });
  }

  private handleSelectOption = index => {
    this.setState({
      selectOptionIndex: index
    }, () => {
			this.handlePurchase()
		});
  }

  private get selectedOption() {
    const { selectOptionIndex, options } = this.state;

    return options[selectOptionIndex] || {};
  }


  /** 替班充值 **/
  private fetchTibanRechargeList = async() => {
		let { tibanOptions } = this.state
		const { body } = await this.apiClient.base.scoresRechargeList({type: 9});

		tibanOptions.map((res, ind) => {
			res.info = body[ind]
		})
		this.setState({
			tibanOptions
		});
  }

  private tibanPurchaseId:any = null
  private handleBeforeTibanPurchase = async(res) => {
    let id = (res && res.info)?res.info.id: null
    if(!id){return;}
    
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }

    this.tibanPurchaseId = id
    if(res.info.value == 1) {
      //包天卡
      this.setState({
        showDayCardModal: true
      })
    }else {
      this.handleTibanPurchase()
    }
  }
  private handleTibanPurchase = async () => {
    let id = this.tibanPurchaseId
    if(!id){return;}

    const response = await this.apiClient.base.purchaseScores({
      type: 9,
			id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('购买成功！');

        // this.setState({
        //   showAlert:true
        // });

        this.fetchScores();
      }
    });
	}
}
